// extracted by mini-css-extract-plugin
module.exports = {"cont-offer__background":"cont-offer__background","contOfferBackground":"cont-offer__background","cont-offer__body":"cont-offer__body","contOfferBody":"cont-offer__body"};